<template>
  <v-row>
    <v-col
      cols="12"
      md="2"
    >
      <v-list
        nav
        dense
      >
        <ProgramList />
      </v-list>
    </v-col>
    <v-col
      cols="12"
      md="10"
    >
      <v-btn
        v-if="isSuperAdmin"
        color="primary darken-1"
        text
        :to="{ name: 'View System Info' }">View System Info
      </v-btn>
      <v-btn
        v-if="isSuperAdmin"
        color="primary darken-1"
        text
        :to="{ name: 'Dev Specific Config' }">*TEST*(Not for PROD)
      </v-btn>
      <v-btn
        v-if="isSuperAdmin"
        color="primary darken-1"
        text
        :to="{ name: 'Migration Manager' }">Migration Manager
      </v-btn>
      <v-tabs
        v-model="activeTab"
        @change="onSystemConfigTabChange"
      >
        <v-tab
          v-for="tab in systemConfigTabs"
          :key="tab.key"
        >
          {{ tab.label }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <GlobalSetting />
        </v-tab-item>
        <v-tab-item>
          <ODSetting />
        </v-tab-item>
        <v-tab-item>
          <WarSetting />
        </v-tab-item>
        <v-tab-item>
          <MiscSetting />
        </v-tab-item>
        <v-tab-item>
          <MtgSetting />
        </v-tab-item>
        <v-tab-item>
          <GLSetting />
        </v-tab-item>
        <v-tab-item>
          <TaxSetting />
        </v-tab-item>
        <v-tab-item>
          <TaxWebSetting />
        </v-tab-item>
        <v-tab-item>
          <StatementsSetting />
        </v-tab-item>
        <v-tab-item>
          <PaymentSetting />
        </v-tab-item>
        <v-tab-item>
          <apportionmnetSetting />
        </v-tab-item>
        <v-tab-item>
          <resaleSetting />
        </v-tab-item>
        <v-tab-item>
          <FileDefinitionSetting />
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import ProgramList from '@/components/common/ProgramList.vue';
import GlobalSetting from '@/components/SystemConfig/GlobalSetting.vue';
import ODSetting from '@/components/SystemConfig/ODSetting.vue';
import WarSetting from '@/components/SystemConfig/WarSetting.vue';
import MiscSetting from '@/components/SystemConfig/MiscSetting.vue';
import MtgSetting from '@/components/SystemConfig/MtgSetting.vue';
import GLSetting from '@/components/SystemConfig/GLSetting.vue';
import TaxSetting from '@/components/SystemConfig/TaxSetting.vue';
import StatementsSetting from '@/components/SystemConfig/StatementsSetting.vue';
import PaymentSetting from '@/components/SystemConfig/PaymentSetting.vue';
import apportionmnetSetting from '@/components/SystemConfig/apportionmnetSetting.vue';
import resaleSetting from '@/components/SystemConfig/resaleSetting.vue';
import FileDefinitionSetting from '@/components/SystemConfig/FileDefinitionSetting.vue';
import { authRoles } from '@/router/roleGroups';
import { isAuthorised } from '../../store/auth/token';
import TaxWebSetting from '../../components/SystemConfig/TaxWebSetting.vue';

const SYSTEM_CONFIG_TABS = [
  { key: 'global', label: 'Global' },
  { key: 'od', label: 'OD' },
  { key: 'war', label: 'WAR' },
  { key: 'misc', label: 'MISC' },
  { key: 'mtg', label: 'MTG' },
  { key: 'gl', label: 'GL' },
  { key: 'tax', label: 'TAX' },
  { key: 'tax-website', label: 'TAX WEBSITE' },
  { key: 'statements', label: 'STATEMENTS' },
  { key: 'payments', label: 'PAYMENTS' },
  { key: 'apportionment', label: 'APPORTIONMENT' },
  { key: 'resale', label: 'RESALE' },
  { key: 'file-definitions', label: 'FILE DEFINITIONS' },
];

export default {
  components: {
    ProgramList,
    GlobalSetting,
    ODSetting,
    WarSetting,
    MiscSetting,
    MtgSetting,
    GLSetting,
    TaxSetting,
    TaxWebSetting,
    StatementsSetting,
    PaymentSetting,
    apportionmnetSetting,
    resaleSetting,
    FileDefinitionSetting,
  },
  data: () => ({
    activeTab: 0,
    systemConfigTabs: SYSTEM_CONFIG_TABS,
  }),
  computed: {
    isSuperAdmin() {
      return isAuthorised(authRoles.SuperAdmin);
    },
  },
  watch: {
    '$route.query.tab': {
      immediate: true,
      handler(tabKey) {
        const idx = SYSTEM_CONFIG_TABS.findIndex((t) => t.key === tabKey);
        this.activeTab = idx >= 0 ? idx : 0;
      },
    },
  },
  methods: {
    onSystemConfigTabChange(index) {
      const key = SYSTEM_CONFIG_TABS[index] && SYSTEM_CONFIG_TABS[index].key;
      if (!key || this.$route.query.tab === key) {
        return;
      }
      this.$router.replace({
        query: { ...this.$route.query, tab: key },
      }).catch(() => {});
    },
  },
};
</script>
